// ルーレットは「1 人 1 回」。倍率自体はくじ券の発行時にサーバで抽選して DB に保存済みなので
// 再アクセスしても結果は変わらないが、回す演出まで毎回出すと「回し直せる」と誤解されるため、
// 一度回したかどうかだけをブラウザに残して 2 回目以降は結果表示に直行する。
//
// くじ券は 1 抽選 × 1 キャンセルで 1 枚 (backend domain/model/lottery.py) なので、
// 同じキャンセルでも再予約側と請求側で「回したか」を別々に持つ。
// 再予約側の key は請求側を足す前から使っているものなので変えないこと
// (変えると回し済みのお客様にもう一度回す演出が出てしまう)。
export type LotteryKind = "rereservation" | "cancel_fee"

const SPUN_STORAGE_KEY_PREFIXES: Record<LotteryKind, string> = {
	rereservation: "rereservation_lottery_spun_v1:",
	cancel_fee: "cancel_fee_lottery_spun_v1:",
}

const spunStorageKey = (kind: LotteryKind, cancelId: string): string =>
	SPUN_STORAGE_KEY_PREFIXES[kind] + cancelId

// localStorage は Safari のプライベートモード等で例外を投げるため、失敗しても演出を壊さない。
export const hasSpunLottery = (
	kind: LotteryKind,
	cancelId: string
): boolean => {
	try {
		return localStorage.getItem(spunStorageKey(kind, cancelId)) !== null
	} catch {
		return false
	}
}

export const markLotteryAsSpun = (
	kind: LotteryKind,
	cancelId: string
): void => {
	try {
		localStorage.setItem(spunStorageKey(kind, cancelId), "1")
	} catch {
		// 記録できなくても倍率は変わらない (DB に保存済み) ので黙って諦める.
	}
}

// 「まだ回していない」状態に戻す. Storybook で回す前/回した後を切り替えるために使う
// (本番導線からは呼ばない).
export const clearLotterySpun = (kind: LotteryKind, cancelId: string): void => {
	try {
		localStorage.removeItem(spunStorageKey(kind, cancelId))
	} catch {
		// 同上.
	}
}

// ルーレットの効果音を消しているかどうか. 1 度消した人には次に開いた時も鳴らさない.
const SOUND_MUTED_STORAGE_KEY = "rereservation_lottery_sound_muted_v1"

// 読めなかった時は「音あり」として扱う.
export const isLotterySoundMuted = (): boolean => {
	try {
		return localStorage.getItem(SOUND_MUTED_STORAGE_KEY) !== null
	} catch {
		return false
	}
}

export const setLotterySoundMuted = (muted: boolean): void => {
	try {
		if (muted) {
			localStorage.setItem(SOUND_MUTED_STORAGE_KEY, "1")
		} else {
			localStorage.removeItem(SOUND_MUTED_STORAGE_KEY)
		}
	} catch {
		// 記録できなくても、その場の切り替えは画面側の state で効いているので黙って諦める.
	}
}
